import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const fullYear = new Date().getFullYear();
    const settingsStore = useSettingsStore();
    const {
      title
    } = storeToRefs(settingsStore);
    // 国家法律法规要求显示备案号 实际项目请自行修改为自己的备案信息及域名
    // const beianShow = ref(false)
    const __returned__ = {
      fullYear,
      settingsStore,
      title
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});